import React from 'react'
import { Dialog } from '@reach/dialog'
import Card from '../Card'

import '@reach/dialog/styles.css'
import styles from './ModalPopup.module.scss'

const ModalPopup = ({
  children,
  onClose,
  open,
  margin = '65%',
  setWidth = '109vw',
  setHeight = '95vh',
  display = 'flex',
  overflow = 'auto',
  center = false,
}) => (
  <Dialog
    className={styles.base}
    role="dialog"
    aria-labelledby="dialog"
    onDismiss={onClose}
    isOpen={open}
    style={
      center
        ? {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: setWidth !== '109vw' ? setWidth : '520px',
            maxHeight: '85vh',
            overflow: 'hidden',
            margin: 0,
          }
        : {
            marginLeft: margin,
            width: setWidth,
            height: setHeight,
            overflow: overflow,
          }
    }
  >
    <Card className={styles.card} primary>
      {children}
    </Card>
  </Dialog>
)

export default ModalPopup
